/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReminderSettingsV1Dto } from './ReminderSettingsV1Dto';
import type { SignatureApproverV1Dto } from './SignatureApproverV1Dto';
import type { SignatureDeclineInformationV1Dto } from './SignatureDeclineInformationV1Dto';
import type { SignatureDocumentV1Dto } from './SignatureDocumentV1Dto';
import type { SignatureEmailNotificationV1Dto } from './SignatureEmailNotificationV1Dto';
import type { SignatureLabelDto } from './SignatureLabelDto';
import type { SignatureSenderV1Dto } from './SignatureSenderV1Dto';
import type { SignatureSignerV1Dto } from './SignatureSignerV1Dto';
export type InitiateSignatureResponseV1Dto = {
  /**
   * Attachments correlating to the email.
   */
  approvers: Array<SignatureApproverV1Dto>;
  /**
   * Locale for the generated audit trail.
   */
  audit_trail_locale: InitiateSignatureResponseV1Dto.audit_trail_locale;
  /**
   * The id of the bulk send batch
   */
  bulk_send_batch_id?: string | null;
  /**
   * The date when the signature was created.
   */
  created_at: string;
  /**
   * The id of the custom experience
   */
  custom_experience_id?: string | null;
  /**
   * Decline information for the signature
   */
  decline_information: SignatureDeclineInformationV1Dto | null;
  /**
   * The delivery mode for the signature
   */
  delivery_mode: InitiateSignatureResponseV1Dto.delivery_mode;
  /**
   * The documents of the signature
   */
  documents: Array<SignatureDocumentV1Dto>;
  /**
   * The email notification of the signature
   */
  email_notification: SignatureEmailNotificationV1Dto;
  /**
   * The expiration date of the signature
   */
  expiration_date: string;
  /**
   * The external id of the signature
   */
  external_id: string | null;
  /**
   * The id of the signature
   */
  id: string;
  /**
   * The labels of the signature
   */
  labels: Array<SignatureLabelDto>;
  /**
   * The name of the signature
   */
  name: string;
  /**
   * The ordered approvers of the signature
   */
  ordered_approvers: boolean;
  /**
   * The ordered signers of the signature
   */
  ordered_signers: boolean;
  /**
   * The reminder settings of the signature
   */
  reminder_settings: ReminderSettingsV1Dto | null;
  /**
   * The sender of the signature
   */
  sender: SignatureSenderV1Dto;
  /**
   * The signers allowed to decline the signature
   */
  signers_allowed_to_decline: boolean;
  /**
   * The signers of the signature
   */
  signers: Array<SignatureSignerV1Dto>;
  /**
   * The source of the signature
   */
  source: InitiateSignatureResponseV1Dto.source;
  /**
   * The status of the signature
   */
  status: InitiateSignatureResponseV1Dto.status;
  /**
   * Time zone of the dates and times displayed in emails, the Signature Request expiration date, and the PDF Audit Trail. Format: tz database. Default is set to Europe/Paris.
   */
  timezone: string;
  /**
   * The id of the workspace
   */
  workspace_id: string;
};
export namespace InitiateSignatureResponseV1Dto {
  /**
   * Locale for the generated audit trail.
   */
  export enum audit_trail_locale {
    DE = 'de',
    EN = 'en',
    ES = 'es',
    FR = 'fr',
    IT = 'it',
    PT = 'pt',
  }
  /**
   * The delivery mode for the signature
   */
  export enum delivery_mode {
    EMAIL = 'email',
    NONE = 'none',
  }
  /**
   * The source of the signature
   */
  export enum source {
    APP = 'app',
    PUBLIC_API = 'public_api',
    HUBSPOT_INTEGRATION = 'hubspot_integration',
    CONNECTOR_SALESFORCE_API = 'connector_salesforce_api',
    CONNECTOR_GOOGLE_API = 'connector_google_api',
    CONNECTOR_ZAPIER_API = 'connector_zapier_api',
  }
  /**
   * The status of the signature
   */
  export enum status {
    APPROVAL = 'approval',
    CANCELED = 'canceled',
    DECLINED = 'declined',
    DELETED = 'deleted',
    DONE = 'done',
    DRAFT = 'draft',
    EXPIRED = 'expired',
    INITIATED = 'initiated',
    ONGOING = 'ongoing',
    REJECTED = 'rejected',
  }
}
